export interface User {
    user: any
}

export interface UserDetails {
    email: string,
    firstName: string,
    lastName: string,
    userName : string
    loginType?: string
    capabilities?: string[]
}
export interface UserState {
    data: User
    userDetails:Object
}

export const CREATE_USER = 'CREATE_USER'
export const USER_DETAILS = 'USER_DETAILS'

interface CreateUserAction {
    type: typeof CREATE_USER
    data: User
}

export interface UserDetailsAction {
    type: typeof USER_DETAILS 
    data: UserDetails
}



export type UserActionTypes = CreateUserAction;
export type UserDetailsTypes= UserDetailsAction
